import { createRoot } from 'react-dom/client';
import { configureStore } from '@reduxjs/toolkit';
import { Provider } from 'react-redux';
import * as singleSpa from 'single-spa';
import { I18nextProvider } from 'react-i18next';
import { registerLicense } from '@syncfusion/ej2-base';
import { EventSourcePolyfill } from 'event-source-polyfill';


import i18n from './services/i18n';
import App from './App.jsx'
import rootReducer from './reducers';
import { loadState, saveState } from './services/state';
import debounce from './services/debounce';
import CookieBot from './components/cookie-bot/CookieBot';
import VersionNotifier from './components/version-notifier/VersionNotifier';
import CrossTabLogoutWatcher from './components/cross-tab-logout-watcher/CrossTabLogoutWatcher';
import { setStore } from './store';
import './index.css'


const SAVE_STATE_DEBOUNCE_PERIOD_IN_MILLIS = 500;
// Asigna la polyfill al objeto window para que esté disponible globalmente
window.EventSourcePolyfill = EventSourcePolyfill;
registerLicense('ORg4AjUWIQA/Gnt2XFhhQlJHfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTH5XdEFjXHxXcnNSRWFYWkdx');
singleSpa.start();

/**
 * Starts application asynchronously once all of the required information is available (loadState)
 *
 * @returns {Promise<void>}
 */
async function init() {
  const previousState = await loadState();
  const store = configureStore({
    reducer: rootReducer,
    preloadedState: previousState,
  });

  // Make store available for API modules
  setStore(store);

  store.subscribe(
    debounce(
      () => saveState(store.dispatch, store.getState()),
      SAVE_STATE_DEBOUNCE_PERIOD_IN_MILLIS
    )
  );

  const root = createRoot(document.getElementById('root'));
  root.render(
    <Provider store={store}>
      <I18nextProvider i18n={i18n}>
        <>
          <CookieBot/>
          <VersionNotifier />
          <CrossTabLogoutWatcher />
          <App />
        </>
      </I18nextProvider>
    </Provider>
  );
}

init();

